import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Link from 'next/link';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Pagination from '@/components/ui/pagination/Pagination';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import Alphabet from '@/components/ui/alphabet/Alphabet';
import { SERIES_FOR_PAGE } from '@/helpers/variables';
import { getAlphabet, getNoun } from '@/helpers/helpers';
import { ISeries, ISeriesData } from '@/interfaces/series.interface';
import styles from './Series.module.scss';

interface ISeriesPrpos extends ISeries {
  letterSign?: string;
}

const Series: FC<ISeriesPrpos> = ({ series, letterSign }) => {
  const pagesCount = Math.ceil(series?.total_count / SERIES_FOR_PAGE);
  const seoPageNumber = series.page > 1 ? `. Cтраница ${series.page}.` : ``;

  //Seo block
  const SEO_TITLE = `Все серии книг${seoPageNumber}`;
  const SEO_DESCRIPTION = 'Cерии книг библиотеки https://fantasy-worlds.ru.';
  const SEO_CANONICAL = '/series';

  const letter = getAlphabet(String(letterSign));
  const paginationUrl = letterSign ? `series/letter/${letterSign}/` : `series/pages/`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Alphabet letterSign={letterSign ? letter : ''} baseUrl="/series/letter/" />
      <Breadcrumbs firstPageName="Cерии" />
      <Pagination pagesCount={pagesCount ?? 0} postName={paginationUrl} />
      <SectionTitle name={letterSign ? `Cерии на букву ${letter}` : `Cерии`} />

      {!!series.data.length ? (
        <>
          <ul className={styles.seriesList}>
            {series.data.map((item: ISeriesData) => (
              <li className={styles.seriesList__item} key={item.id}>
                <Link prefetch={false} href={`/series/${item.title_translit}`} className={styles.seriesList__itemLink}>
                  <span className={styles.seriesList__itemTxt}>{item.title}</span>
                  <span className={styles.seriesList__itemCount}>
                    {item.book_count}
                    <span className={styles.seriesList__itemWord}> {getNoun(item.book_count, 'книга', 'книги', 'книг')}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div className={`${styles.seriesTitle} ${styles.seriesTitle_mb}`}>{`Cерии не найдены`}</div>
      )}

      <Pagination pagesCount={pagesCount ?? 0} postName={paginationUrl} />
    </Layout>
  );
};

export default Series;
